<!--
 * @Author: yeqing
 * @Date: 2021-11-24 09:54:08
 * @LastEditTime: 2021-11-30 17:59:53
 * @LastEditors: wumao
 * @Description: 中小企业测评结果
 * @FilePath: \fe-frame-page\src\views\enterpriseSpecial\smEvaluation\result.vue
-->
<template>
  <div class="container">
    <header class="header">
      <a-button :loading="loading" class="share" @click="visible = true">分享</a-button>
      <a-button type="primary" @click="downloadPdf" :loading="loading || downloadLoading" class="btn">下载</a-button>
    </header>
    <div class="content">
      <!-- pdf 容器 -->
      <div class="left" ref="left" @scroll="onLeftScroll">
        <ResultCover ref="cover" :resultData="resultData" />
        <ResultCatalogue ref="cata" style="marginTop:20px" :resultData="resultData" />
        <ResultPageOne ref="page1" style="marginTop:20px" :resultData="resultData" />
        <ResultPageTwo ref="page2" style="marginTop:20px" :resultData="resultData" />
        <ResultPageThree ref="page3" style="marginTop:20px" :resultData="resultData" />
      </div>
      <!-- 缩略图 -->
      <div class="right" ref="right" @click="onClick($event)"></div>
    </div>

    <QrCode v-if="visible" desc="微信扫描二维码，分享报告" businessType="littleGiantEvaReport" :visiable.sync="visible" :maskClosable="false" :url="pdfUrl" targetDesc="专精特新小巨人测评报告" :targetId="resultData.recordId" />
  </div>
</template>

<script>
import ResultCover from './pdfComponents/resultCover.vue'
import ResultCatalogue from './pdfComponents/resultCatalogue.vue'
import ResultPageOne from './pdfComponents/resultPageOne.vue'
import ResultPageTwo from './pdfComponents/resultPageTwo.vue'
import ResultPageThree from './pdfComponents/resultPageThree.vue'
import QrCode from '@/components/qrCode'

import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'
import { pdfUploadApi, pdfDownloadApi } from '@/api/enterpriseSpecial'

const SCALE = 3 //缩放比例

export default {
  name: 'SmEvaluationResult',
  data() {
    return {
      heightArr: [0], // pdf 每页高度集合
      imgs: [], //img dom元素集合
      activeIndex: 0,
      resultData: {},
      pdfUrl: '',
      loading: false,
      downloadLoading: false,
      visible: false,
    }
  },
  components: {
    ResultCover,
    ResultCatalogue,
    ResultPageOne,
    ResultPageTwo,
    ResultPageThree,
    QrCode,
  },
  created() {
    const resultData = JSON.parse(sessionStorage.getItem('resultData'))
    this.resultData = resultData
  },
  mounted() {
    this.loading = true
    setTimeout(() => {
      this.uploadPdf()
    }, 1000)
  },
  methods: {
    onLeftScroll(e) {
      const scrollTop = e.target.scrollTop
      const heightArr = this.heightArr
      for (let i = 0; i < heightArr.length; i++) {
        let currentH = heightArr[i]
        let nextH = heightArr[i + 1]
        if (currentH <= scrollTop && scrollTop <= nextH) {
          this.activeIndex = i
          // this.addActiveClass(i)
        }
      }
    },
    onClick(e) {
      const index = e.target.getAttribute('index')
      if (index === null) {
        return
      }
      this.addActiveClass(index)
      this.$refs.left.scrollTop = this.heightArr[index]
    },
    async downloadPdf() {
      this.downloadLoading = true
      await pdfDownloadApi(this.resultData.recordId)
      this.downloadLoading = false
      this.doc && this.doc.save('专精特新小巨人测评报告.pdf')
    },
    async uploadPdf() {
      this.loading = true
      const file = await this.generatePdfFile()
      const formData = new FormData()
      formData.append('file', file)
      formData.append('recordId', this.resultData.recordId)
      const res = await pdfUploadApi(formData)
      this.loading = false
      this.pdfUrl = res.data
    },
    async generatePdfFile() {
      const imgs = await Promise.all([this.html2img(this.$refs.cover.$el), this.html2img(this.$refs.cata.$el), this.html2img(this.$refs.page1.$el), this.html2img(this.$refs.page2.$el), this.html2img(this.$refs.page3.$el)])
      this.imgs = imgs
      if (imgs.length) {
        this.doc = new jsPDF('p', 'px', [imgs[0].naturalWidth / SCALE, imgs[0].naturalHeight / SCALE])
        for (let i = 0; i < imgs.length; i++) {
          const img = imgs[i]
          this.doc.addImage(img, 0, 0, img.naturalWidth / SCALE, img.naturalHeight / SCALE)
          // 如果有下一张图片，就添加一张pdf页面
          if (i + 1 < imgs.length) {
            const nextImg = imgs[i + 1]
            this.doc.addPage([nextImg.naturalWidth / SCALE, nextImg.naturalHeight / SCALE])
          }
        }
        // doc.save('test.pdf')
        const arraybuffer = this.doc.output('arraybuffer')
        return this.arrayBuffer2file(arraybuffer, '专精特新小巨人测评报告')
      }
    },
    // html 转为 img 对象
    html2img(dom) {
      return new Promise((resolve, reject) => {
        html2canvas(dom, { scale: SCALE }).then((canvas) => {
          let image = new Image()
          image.onload = () => {
            resolve(image)
          }
          image.onerror = (err) => {
            reject(err)
          }
          image.src = canvas.toDataURL('image/jpeg', 1.0)
        })
      })
    },
    arrayBuffer2file(arrayBuffer, name) {
      return new File([arrayBuffer], name)
    },
    addActiveClass(index) {
      this.imgs.forEach((img) => {
        img.classList.remove('active')
      })
      this.imgs[index].classList.add('active')
    },
  },
  watch: {
    imgs: {
      handler(imgArr) {
        if (Array.isArray(imgArr) && imgArr.length) {
          imgArr.forEach((img, i) => {
            // 把生成的图片 appendChild 到 right 容器中当缩略图
            img.classList.add('thumbnail')
            img.setAttribute('index', i)
            this.$refs.right.appendChild(img)

            // 计算高度
            const heightArr = this.heightArr
            const lastItem = heightArr[heightArr.length - 1]
            heightArr.push(lastItem + img.naturalHeight / SCALE + 20)
          })
        }
      },
    },
    activeIndex: {
      handler(index) {
        if (!this.imgs.length) return
        this.addActiveClass(index)
      },
      immediate: true,
    },
  },
}
</script>
<style lang="less" scoped>
.container {
  height: 100vh;

  .header {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 0 20px;
    .share {
      margin-right: 20px;
      &:hover {
        color: #0072f7;
        border-color: #0072f7;
      }
    }
    .btn {
      background-color: #0072f7;
      color: #fff;
    }
  }
  .content {
    width: 1000px;
    padding: 20px;
    box-sizing: border-box;
    height: calc(100% - 70px);
    overflow: hidden;
    border: 1px solid #eee;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    .left {
      width: 800px;
      height: 100%;
      overflow: auto;
      scroll-behavior: smooth;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      -ms-overflow-style: none; /* IE 10+ */
      scrollbar-width: none; /* Firefox */
    }
    .right {
      width: 140px;
      box-sizing: border-box;
      height: 100%;
      overflow: auto;
      scroll-behavior: smooth;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
      display: flex;
      flex-direction: column;
      align-items: center;
      &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
      }
      -ms-overflow-style: none; /* IE 10+ */
      scrollbar-width: none; /* Firefox */
      padding: 10px;
    }
  }
}
</style>

<style lang="less">
.thumbnail {
  width: 100px;
  height: 150px;
  border: 1px solid #eee;
  &:not(:first-child) {
    margin-top: 20px;
  }
  &:hover {
    border: 1px solid #0072f7;
  }
  &.active {
    border: 1px solid #0072f7;
  }
}
</style>
